import { render, staticRenderFns } from "./CreateConcept.vue?vue&type=template&id=f4af19d2&scoped=true&"
import script from "./CreateConcept.vue?vue&type=script&lang=ts&"
export * from "./CreateConcept.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConcept.vue?vue&type=style&index=0&id=f4af19d2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af19d2",
  null
  
)

export default component.exports